export default "__VITE_ASSET__BVmYPrsg__"